import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ReadingsService } from 'src/services/readings/readings.service';
import { LatestReadingsResponse } from 'src/types/readings/readings';

type UseGetLatestGatewayReadingsArgs = {
  gatewayId?: string;
  tagId?: string | string[];
};

export const useGetLatestGatewayReadingsQuery = ({
  gatewayId,
  tagId,
}: UseGetLatestGatewayReadingsArgs) => {
  const queryClient = useQueryClient();
  const enabled = !!gatewayId && !!tagId;

  const queryKey = ['latestReadings', gatewayId, tagId];

  const { data, isSuccess, isFetching, isFetched } = useQuery<LatestReadingsResponse>({
    queryKey,
    queryFn: () =>
      ReadingsService.getLatestReadingsNewDataStorage({
        gatewayId: gatewayId!,
        measurements: tagId!,
      }).then((res): LatestReadingsResponse => res?.data ?? {}),
    enabled,
    staleTime: 1000 * 60 * 2, // 2 min cache
    placeholderData: () => queryClient.getQueryData(queryKey) as LatestReadingsResponse,
  });

  return {
    latestReading: data ?? {},
    isDataReady: isSuccess && isFetched && !isFetching,
  };
};
